import { FC } from 'react';

import { Logs } from 'utils/types';

import _Logs from './ActivityLog';

interface PROPS {
  data: Logs;
}

const ActivityDetails: FC<PROPS> = ({ data }) => {
  const description = () => {
    const log = _Logs[data.source][data.action];

    if (!log || !log.element) return null;

    return log.element(data);
  };

  return description();
};

export default ActivityDetails;
